import { PAGE_TITLES } from "@miplatform/constants";
import { Schedule } from "../../views/Schedule/Schedule";

export const dispatchRoutes = [
  {
    path: "/dispatch",
    name: "Dispatch",
    element: <Schedule />,
    handle: { title: PAGE_TITLES.DISPATCH },
  },
  {
    path: "/dispatch/:id",
    name: "Dispatch",
    element: <Schedule />,
    handle: { title: PAGE_TITLES.DISPATCH },
  },
];
